import { render, staticRenderFns } from "./PostRegistrationTab.vue?vue&type=template&id=32da0fc0&scoped=true"
import script from "./PostRegistrationTab.vue?vue&type=script&lang=js"
export * from "./PostRegistrationTab.vue?vue&type=script&lang=js"
import style0 from "./PostRegistrationTab.vue?vue&type=style&index=0&id=32da0fc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32da0fc0",
  null
  
)

export default component.exports